export const INSTITUTE_ID_ACADEMIC = "ed810ec3-ab45-c914-f12e-d9a857d560a6";
export const INSTITUTE_ID_ACADEMIC_SPORT =
  "4edf8179-e313-c992-ab28-0475d99f9110";

export const PROFILE_FIELD_TYPES = [
  {
    id: 1,
    typeName: "String",
    disabled: false,
  },
  {
    id: 2,
    typeName: "Number",
    disabled: false,
  },
  {
    id: 3,
    typeName: "Boolean",
    disabled: false,
  },
  {
    id: 4,
    typeName: "Radio",
    disabled: false,
  },
  {
    id: 5,
    typeName: "Select",
    disabled: false,
  },
  {
    id: 6,
    typeName: "Multi-Select",
    disabled: true,
  },
  {
    id: 7,
    typeName: "Array",
    disabled: false,
  },
  {
    id: 8,
    typeName: "Date",
    disabled: false,
  },
  {
    id: 9,
    typeName: "Image",
    disabled: false,
  },
];

export const PROFILE_FIELD_VALUE_TYPES = [
  {
    id: 1,
    typeName: "Single Line",
    value: "textfield",
  },

  {
    id: 2,
    typeName: "Multi Line",
    value: "textview",
  },
];

export const PROFILE_FIELD_NAME_ID = "3b9107bc-27e2-022d-36fd-76ef115670d3";

export const PROFILE_FIELD_IMAGE_ID = "7787eac5-eccc-0cf4-cea4-d9344ddaa07f";

//  My Interest (Usage of Profile Fields)
export const MY_INTEREST_ID = "cebafd23-25d2-754b-ba29-972a369571f2";

// Personal Development Subsection IDs (Usage of Profile Fields)
export const TRIPS_EVENTS_EXPERIENCES_ID =
  "2cd6314b-9881-4f35-e9a2-02adf85bb5d2";
export const PRESENTATIONS_AWARDS_ID = "b5771cf4-7a2f-1e53-7cca-5f2546401714";
export const COMMUNITY_CHARITY_WORK_ID = "1486b5bc-4466-092c-4045-bfa1c9051215";

// Physical attributes (Usage of Profile Fields)
export const PHYSICAL_ATTRIBUTES_ID = "92879481-a132-db2b-7aa0-02b00ac6777f";

// Previous Employment (Usage of Profile Fields)
export const PREVIOUS_EMPLOYMENT_ID = "f7e8d9c0-b1a2-3456-7890-abcdef123456";

export const INSTITUTE_TYPE_ID_FOOTBALL =
  "cbfe115b-a362-a964-e44e-156e6d9c989e";

export const PROFILE_FIELD_CATEGORIES = [
  {
    id: 1,
    typeName: "About Me",
  },
  {
    id: 2,
    typeName: "Education",
  },
  {
    id: 3,
    typeName: "Personal Development",
  },
  {
    id: 4,
    typeName: "Previous Experience",
  },
  {
    id: 5,
    typeName: "Performance Stats",
  },
  {
    id: 6,
    typeName: "Physical Attributes",
  },
  {
    id: 7,
    typeName: "Transferable Skills",
  },
];
